import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { addDocTypeApi } from "../../../../api/docType";
import { getAccessToken } from "../../../../api/auth";

import "./AddDocTypeForm.scss";

export default function AddDocTypeForm(props) {
  const { setIsVisibleModal, setReloadDocTypes } = props;

  const [inputs, setInputs] = useState({
    //doctype_code: "",
    description: "",
  });

  const isFormValid = (e) => {
    //console.log(inputs);
    let errorExists = false;
    if (!inputs.description) {
      notification["error"]({
        message: "Obligatorio: descripción.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addDocType = async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      const accessToken = getAccessToken();

      await addDocTypeApi(accessToken, inputs)
        .then((response) => {
          if (
            response === "ERR_CONNECTION_REFUSED" ||
            response === "Failed to fetch" ||
            response === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
          } else if (response.code !== 200) {
            notification["error"]({
              message: response.message,
            });
          } else {
            notification["success"]({
              message: "Tipo de documento creado",
            });
            setIsVisibleModal(false);
          }
          setReloadDocTypes(true);
        })
        .catch((err) => {
          notification["error"]({
            message: err,
          });
        });
    }
  };

  return (
    <div className="add-doctype-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        addDocType={addDocType}
      />
    </div>
  );
}

function AddForm(props) {
  const { inputs, setInputs, addDocType } = props;

  return (
    <Form className="form-add" onSubmit={addDocType}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.doctype_code}
              onChange={(e) => setInputs({ ...inputs, doctype_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">*</span> Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripcion"
              value={inputs.description}
              onChange={(e) =>
                setInputs({ ...inputs, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addDocType}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
